<h4 class="mb-3 mt-4">{{ title ?? 'Notes' }}</h4>
<div [innerHTML]="getProcessedHTML()"></div>
